import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';

@Component({
  selector: 'app-ticket-task-priority-definition',
  templateUrl: './ticket-task-priority-definition.component.html',
  styleUrls: ['./ticket-task-priority-definition.component.css']
})
export class TicketTaskPriorityDefinitionComponent implements OnInit {

  form: any | FormGroup;
  editForm: any | FormGroup;
  dataList: any = [];
  singleRecord: any = [];
  
  page: number = 1;
  count: number = 0;
  tableSize: number = 10;
  tableSizes: any = [3, 6, 9, 12];
  cid: any;
  first: number = 0;
  isLoading: any = false;

  actionControls: any = {
    isAdd: false,
    isView: false,
    isDelete: false,
    isModify: false
  };

  id: any = "";
  recordName: any = "";
  recordId: any = "";
  searchKey: any = "";

  constructor(private fb: FormBuilder, private toastr: ToastrService, private generic_service: GenericService) { }

  ngOnInit(): void {
    let href: any = window.location.href;
    let messages = href.split('/');
    let action: any = this.generic_service.checkActionControls(messages[messages.length - 1]);
    if (action) {
      this.actionControls = action;
    } else {
      // default permissions if not configured
      this.actionControls = {
        isAdd: true,
        isView: true,
        isDelete: true,
        isModify: true
      };
    }

    this.cid = sessionStorage.getItem('cid');
    this.getAllData();
    
    this.form = this.fb.group({
      priorityStatus: ['', [Validators.required]],
      timeInHrs: ['', [Validators.required]],
      description: ['']
    });
    
    this.editForm = this.fb.group({
      priorityStatus: ['', [Validators.required]],
      timeInHrs: ['', [Validators.required]],
      description: ['']
    });
  }

  onTableDataChange(event: any) {
    this.page = event;
    this.getAllData();
  }
  
  onTableSizeChange(event: any): void {
    this.tableSize = event.target.value;
    this.page = 1;
    this.getAllData();
  }

  addRecord() {
    if (!this.form.valid) {
      this.toastr.error("please fill required fields");
      return;
    }

    const priorityStatus = this.form.get('priorityStatus').value;
    const timeInHrs = this.form.get('timeInHrs').value;
    const description = this.form.get('description').value?.trim();

    let body = {
      "version": 0,
      "isActive": true,
      "description": description || '',
      "priorityStatus": priorityStatus,
      "timeInHrs": timeInHrs,
      "cid": this.cid
    };

    this.generic_service.addTicketTaskPriorityDefinition(body).subscribe(
      (response: any) => {
        this.getAllData();
        this.cancelModel();
        this.form.reset();
        this.toastr.success(response.message || "Record added successfully");
      },
      (error: any) => {
        if(error?.error?.errors?.length > 0) {
           this.toastr.error(error.error.errors[0].description);
        } else {
           this.toastr.error("Error adding record");
        }
      }
    );
  }

  updateRecord() {
    if (!this.editForm.valid) {
      this.toastr.error("please fill required fields");
      return;
    }

    const priorityStatus = this.editForm.get('priorityStatus').value;
    const timeInHrs = this.editForm.get('timeInHrs').value;
    const description = this.editForm.get('description').value?.trim();

    let body = {
      "id": this.id,
      "ticketTaskPriorityDefinitionId": this.recordId,
      "version": 0,
      "isActive": true,
      "description": description || '',
      "priorityStatus": priorityStatus,
      "timeInHrs": timeInHrs,
      "cid": this.cid
    };

    this.generic_service.updateTicketTaskPriorityDefinition(body).subscribe(
      (response: any) => {
        this.getAllData();
        document.getElementById("closeModalButtonEdit")?.click();
        this.editForm.reset();
        this.toastr.success(response.message || "Record updated successfully");
      },
      (error: any) => {
        if(error?.error?.errors?.length > 0) {
           this.toastr.error(error.error.errors[0].description);
        } else {
           this.toastr.error("Error updating record");
        }
      }
    );
  }

  formReset() {
    this.form.reset();
    this.editForm.reset();
  }

  cancelModel() {
    document.getElementById("closeModalButton")?.click();
  }

  getAllData() {
    this.isLoading = true;

    this.generic_service.getAllTicketTaskPriorityDefinitions().subscribe(
      (res: any) => {
        if (res.response) {
            this.dataList = res.response;
            this.count = res.response.length;
        } else {
            this.dataList = [];
            this.count = 0;
        }
        this.isLoading = false;
      },
      (err: any) => {
        console.log(err);
        this.isLoading = false;
      }
    );
  }

  getById(id: any, mode: string) {
    this.id = id;
    this.generic_service.getTicketTaskPriorityDefinitionById(id).subscribe(
      (res: any) => {
        this.singleRecord = [];
        this.singleRecord.push(res.response);
        this.recordId = res.response.ticketTaskPriorityDefinitionId || res.response.id;
        if (mode === 'edit') {
            this.editForm.patchValue({
              priorityStatus: res.response.priorityStatus,
              timeInHrs: res.response.timeInHrs,
              description: res.response.description,
            });
        }
      },
      (err: any) => {
        console.log(err);
      }
    );
  }

  deleteRecord() {
    this.generic_service.deleteTicketTaskPriorityDefinition(this.id).subscribe(
      (response: any) => {
        document.getElementById("deleteModalButton")?.click();
        this.toastr.success(response.message || "Record deleted successfully");
        this.getAllData();
        this.recordName = "";
        this.recordId = "";
      },
      (error: any) => {
        if(error?.error?.errors?.length > 0) {
           this.toastr.error(error.error.errors[0].description);
        } else {
           this.toastr.error("Error deleting record");
        }
      }
    );
  }

  selectDelete(id: any, record: any) {
    this.id = id;
    this.recordId = record.ticketTaskPriorityDefinitionId || record.id;
    this.recordName = record.priorityStatus || record.description;
  }

  closeModal() {
    this.recordId = "";
    this.recordName = "";
  }

  getAllByWildSearchWithoutPagination() {
    if (this.searchKey == "" || this.searchKey == null) {
      return;
    }
    this.generic_service.getAllTicketTaskPriorityDefinitionByWildSearchWithoutPagination(this.searchKey).subscribe(
      (res: any) => {
        if (res.response == null || res.response.length == 0 || res.response == undefined) {
          this.dataList = [];
          this.count = 0;
          return;
        }
        this.dataList = res.response;
        this.count = res.response.length;
      },
      (err: any) => {
        console.log(err);
      }
    );
  }

  refreshAll() {
    this.page = 1;
    this.first = 0;
    this.searchKey = "";
    this.getAllData();
  }
}
